//
//
//
//
//
//
//
//
//
//
import { uuid } from '@/views/visual/dataScreen/js/utils/utils';
import create from "../../create";
export default create({
  name: "clapper",
  data: function data() {
    return {
      hid: 'main_' + uuid(),
      reload: true,
      config: {}
    };
  },
  computed: {
    autoplay: function autoplay() {
      return this.option.autoplay;
    }
  },
  watch: {
    dataChart: {
      handler: function handler() {
        var _this = this;

        this.reload = false;
        this.$nextTick(function () {
          _this.reload = true;
          setTimeout(function () {
            new Clappr.Player({
              parentId: '#' + _this.hid,
              source: _this.dataChart.value,
              autoPlay: _this.autoplay,
              mute: true,
              height: '100%',
              width: '100%'
            });
          });
        });
      },
      deep: true
    }
  },
  methods: {
    handleClick: function handleClick() {
      this.clickFormatter && this.clickFormatter({
        data: this.dataChart
      }, this.getItemRefs());
    }
  }
});